<script>
    import reportService from "../v2-service.js";
    import snapshotService from "../../snapshot/service.js";
    import summaryService from "../../_summary/service.js";
    import DownloadReportRow from "../../../components/powerTable/download-report-row.svelte";
    import { notificate } from "../../../services/notification.js";
    import BreadCrumNav from "../../../components/breadcrum-nav.svelte";
    import { PowerTable } from "@muonw/powertable";
    import Form from "./_form.svelte";
    import { onMount, onDestroy, tick } from "svelte";
    import * as bootstrap from "bootstrap";
    import powerTableService from "../../../services/powerTable.js";
    import { user } from "../../user/user.state.svelte.js";
    import { format, locale } from "svelte-i18n";
    import SnapshotModal from "../../snapshot/_components/report-modal.svelte";
    import dayjs from "dayjs";
    import relativeTime from "dayjs/plugin/relativeTime";
    import localizedFormat from "dayjs/plugin/localizedFormat";
    import "dayjs/locale/es";
    import "dayjs/locale/en";

    dayjs.locale($locale);
    dayjs.extend(relativeTime);
    dayjs.extend(localizedFormat);

    let reports = $state([]);
    let selected_rows = $state([]);
    let checkbox;
    let tableElement = $state();
    let snapshot = $state({});
    let filters = $state({
        asset_tag: "",
        finding_tag: "",
        vulnerability_tag: "",
        asset_kind__in: "",
    });
    let tags = [];
    let summaries = [];
    let refresh = $state(false);
    let is_requesting = $state(false);
    let is_loading_snapshot = $state(false);
    let error = $state();
    let loadingHTML = $state(false);

    let editingReport = $state(null);

    let optionsTranslations = {
        asset_tag_id: $format("page.report.options.asset_tag_id"),
        finding_tag_id: $format("page.report.options.finding_tag_id"),
        vulnerability_tag_id: $format("page.report.options.vulnerability_tag_id"),
        summary_id: $format("page.report.options.summary_id"),
        template: $format("page.report.options.template"),
    };

    const openModal = (elementId) => {
        const el = document.getElementById(elementId);
        if (!el) return;

        try {
            const bs = typeof bootstrap !== "undefined" ? bootstrap : window.bootstrap;
            const ModalClass = bs?.Modal || bs?.default?.Modal || window?.bootstrap?.Modal;
            if (ModalClass) {
                const inst = ModalClass.getOrCreateInstance ? ModalClass.getOrCreateInstance(el) : new ModalClass(el);
                inst.show();
                return;
            }
        } catch (err) {
            console.warn("Bootstrap JS show failed, applying DOM fallback", err);
        }

        el.classList.add("show");
        el.style.display = "block";
        el.removeAttribute("aria-hidden");
        el.setAttribute("aria-modal", "true");
        el.setAttribute("role", "dialog");

        if (!document.querySelector(".modal-backdrop")) {
            const backdrop = document.createElement("div");
            backdrop.className = "modal-backdrop fade show";
            document.body.appendChild(backdrop);
        }
        document.body.classList.add("modal-open");
    };

    const closeModal = (elementId) => {
        const el = document.getElementById(elementId);
        
        if (elementId === "report-edit-modal") {
            editingReport = null;
        }

        if (!el) return;

        try {
            const bs = typeof bootstrap !== "undefined" ? bootstrap : window.bootstrap;
            const ModalClass = bs?.Modal || bs?.default?.Modal || window?.bootstrap?.Modal;
            if (ModalClass) {
                const inst = ModalClass.getInstance ? ModalClass.getInstance(el) : null;
                if (inst) {
                    inst.hide();
                    return;
                }
            }
        } catch (err) {
            console.warn("Bootstrap JS hide failed, applying DOM fallback", err);
        }

        el.classList.remove("show");
        el.style.display = "none";
        el.setAttribute("aria-hidden", "true");
        el.removeAttribute("aria-modal");

        document.body.classList.remove("modal-open");
        document.body.style.removeProperty("padding-right");
        document.body.style.removeProperty("overflow");
        document.querySelectorAll(".modal-backdrop").forEach((b) => b.remove());
    };

    const parseRows = (pageContent) => {
        pageContent.forEach((row) => {
            if (row["created_at"]) {
                row["created_at"] = dayjs(row["created_at"]).format("YYYY/MM/DD, h:mm:ss a");
            }
            if (row["updated_at"]) {
                row["updated_at"] = dayjs(row["updated_at"]).format("YYYY/MM/DD, h:mm:ss a");
            }

            row.download = {
                id: row.id,
                template: row.template,
                created_at: row.created_at,
                options: row.options,
            };

            if (row["template"]) {
                if (row.template.includes("pdf")) row.template = "PDF";
                if (row.template.includes("html")) row.template = "HTML";
            }
            row.description = row["description"] || "";

            if (row["options"]) {
                let optionsRow = "";
                let options = row.options.split("&");
                for (let option of options) {
                    if (option.includes("%2F")) option = option.split("%2F")[0];
                    if (!option.includes("template") && !option.includes("summary_id")) {
                        let tag_id = option.split("=")[1];
                        let tag = tags.find((t) => t.id == tag_id);
                        if (tag) {
                            optionsRow += `<div>${optionsTranslations[option.split("=")[0]]}: <a href="/tag/${tag.id}">${tag.name}</a></div>`;
                        }
                    }
                    if (option.includes("summary_id")) {
                        let summary_id = option.split("=")[1];
                        let summary = summaries.find((sum) => sum.id == summary_id);
                        if (summary) {
                            optionsRow += `<div>${optionsTranslations[option.split("=")[0]]}: ${summary.name}</div>`;
                        }
                    }
                    if (option.includes("template") || option.includes("language")) {
                        let lang = option.includes("language=es") || option.includes("spanish")
                            ? $format("page.report.options.spanish")
                            : $format("page.report.options.english");
                        optionsRow += `<div>${$format("page.report.options.template")}: ${lang}</div>`;
                    }
                }
                row.options = optionsRow;
            }
        });
        deselectAll();
        return pageContent;
    };

    let ptOptions = $state({
        uniquePrefix: "reportsTable",
        rowsPerPageOptions: [10, 20, 50, 100],
        footerText: false,
        footerFilters: false,
        footerLoadingBar: false,
        segments: {
            pTable: ["table"],
            bottomBar: ["dropdown", "stats", "pagination"],
        },
        translations: {
            add: $format("list.interface.add"),
            delete: $format("list.interface.delete"),
            filterBy: $format("list.interface.filterBy"),
            from: $format("list.interface.from"),
            invertSelection: $format("list.interface.invertSelection"),
            next: $format("list.interface.next"),
            of: $format("list.interface.of"),
            previous: $format("list.interface.previous"),
            rows: $format("list.interface.rows"),
            search: $format("list.interface.search"),
            selectAll: $format("list.interface.selectAll"),
            selectNone: $format("list.interface.selectNone"),
        },
        isDataRemote: false,
        userFunctions: {
            customParse: parseRows,
        },
    });

    let instructs = [
        { key: "select", title: "", filterable: false, sortable: false },
        { key: "created_at", title: $format("list.columns.created"), filterable: false },
        { key: "updated_at", title: $format("list.columns.updated"), filterable: false },
        { key: "description", title: $format("list.columns.description"), filterable: false },
        { key: "options", title: $format("list.columns.options"), filterable: false, parseAs: "unsafe-html" },
        { key: "template", title: $format("list.columns.format"), filterable: false },
        { key: "created_by", title: $format("list.columns.created_by"), filterable: false },
        { key: "download", title: $format("list.columns.download"), filterable: false, parseAs: "component", dataComponent: DownloadReportRow },
    ];

    const getData = async (config) => {
        is_requesting = true;
        try {
            let pReports = await reportService.search(config);
            reports = pReports.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
        } catch (e) {
            notificate(e.message || "Error fetching data");
        } finally {
            is_requesting = false;
        }

        closeModal("snapshot-report-modal");
        await getSummaries();
        
        refresh = !refresh;
    };

    const getSummaries = async (config = { filter: {} }) => {
        summaries = await summaryService.search();
        return summaries;
    };

    const selectAll = async (e) => {
        let tData = tableElement.getData(false, ["pageData", "matchedData"]);
        let pageData = tData.pageData;
        if (!pageData || pageData.length === 0) return selected_rows;

        const selectedIds = new Set(selected_rows.map((r) => r.id));
        const allPageSelected = pageData.every((el) => selectedIds.has(el.id));

        let action = allPageSelected ? "deselect" : "select";

        if (action === "select") {
            let result;
            if (tData.matchedData.length > 10) {
                result = await notificate("select_all", "modal", {});
                if (!result.isConfirmed && result.dismiss !== "cancel") return selected_rows;
            }

            let target_elements = result && result.isConfirmed ? tData.matchedData : pageData;
            const currentIds = new Set(selected_rows.map((x) => x.id));
            let toAdd = target_elements.filter((x) => !currentIds.has(x.id));

            selected_rows = [...selected_rows, ...toAdd];
        } else {
            selected_rows = [];
        }

        powerTableService.toggleActionButtons(selected_rows);

        const domRows = document.querySelectorAll(`div[data-prefix='reportsTable'] table tbody tr`);
        const selectedPtIds = new Set(selected_rows.map((r) => String(r.__PT_ID__)));

        domRows.forEach((row) => {
            let rowId = row.getAttribute("data-id");
            if (selectedPtIds.has(rowId)) {
                row.classList.add("selected");
            } else {
                row.classList.remove("selected");
            }
        });

        return selected_rows;
    };

    const deselectAll = () => {
        selected_rows = powerTableService.deselectAll();
        powerTableService.toggleActionButtons(selected_rows);
        return selected_rows;
    };

    const selectAllEventListener = () => {
        checkbox = document.querySelector("th[data-key='select'][data-sortable='false']");
        if (checkbox) {
            checkbox.addEventListener("click", selectAll);
        }
    };

    const selectRow = (event) => {
        let tData = tableElement.getData(false, [
            "options", "instructs", "data", "search", "filters", "pageData", "matchedData",
        ]);
        let current = event.detail.data;
        let idx = selected_rows.findIndex((r) => r.id == current.id);
        selected_rows = powerTableService.selectRows(
            selected_rows, current, idx, "reportsTable", tData.pageData,
        );
        powerTableService.toggleActionButtons(selected_rows);
        return selected_rows;
    };

    const handleDelete = async (data) => {
        let result = await notificate("confirm_delete", "modal", { massive: true, findings_warning: false });
        if (!result.isConfirmed) return false;

        is_requesting = true;
        let ids = selected_rows.map((row) => row.id);
        let reportsToDelete = data.filter((report) => ids.includes(report.id));

        try {
            for (let report of reportsToDelete) {
                await reportService.del(report.id);
            }
            notificate("delete_ok", "toast", {
                is_massive: reportsToDelete.length > 1,
                data: reportsToDelete.length > 1 ? $format("page.report.title") : "Reporte",
            });
        } catch (errors) {
            console.error(errors);
        } finally {
            is_requesting = false;
            await getData();
        }
    };

    const handleEdit = async () => {
        if (selected_rows.length < 1) return notificate("select_element", "modal");
        if (selected_rows.length > 1) return notificate("select_only_one", "modal");

        editingReport = { ...selected_rows[0] };
        await tick();

        openModal("report-edit-modal");
    };

    const handleCancel = () => {
        closeModal("report-edit-modal");
    };

    const handlePatchFunction = async () => {
        closeModal("report-edit-modal");
        await getData();
    };

    const saveNewSnapshot = async () => {
        is_loading_snapshot = true;
        let response = await snapshotService.save(true);
        await getSnapshotDetail(response.id, {});
        is_loading_snapshot = false;
    };

    const getSnapshotDetail = async (id, config = {}) => {
        if (config.resetFilters) resetFilters(filters, config.resetFilters);
        let response = await snapshotService.find(id, config);
        return (snapshot = response);
    };

    const updateFilterValue = (filtersData, key, value) => {
        filtersData[key] = value;
    };

    const resetFilters = (filtersData, keys = []) => {
        if (!keys) return;
        for (let key of keys) {
            filtersData[key] = "";
        }
    };

    const getFormattedDate = (dateString) => {
        return dayjs(dateString).format("YYYY/MM/DD.HHmmss");
    };

    const handleReportDownload = async (
        config = { filter: { language: $locale } },
        summary_id,
        should_save = false,
    ) => {
        is_requesting = true;
        if (error) error = null;

        let file_name;
        let cr_at = getFormattedDate(snapshot.created_at);

        if (config.filter.language.includes("es")) {
            if (config.filter.format.includes("html")) {
                file_name = `${cr_at}.vulseek.reporte.html`;
            } else if (config.filter.format.includes("markdown")) {
                file_name = `${cr_at}.vulseek.reporte.md`;
            } else {
                file_name = `${cr_at}.vulseek.reporte.pdf`;
            }
        }
        if (!config || !config.filter.language || config.filter.language.includes("en")) {
            if (config.filter.format && config.filter.format.includes("html")) {
                file_name = `${cr_at}.vulseek.report.html`;
            } else if (config.filter.format.includes("markdown")) {
                file_name = `${cr_at}.vulseek.report.md`;
            } else {
                file_name = `${cr_at}.vulseek.report.pdf`;
            }
        }

        loadingHTML = true;

        let file = await snapshotService
            .getReport(config, summary_id, snapshot.id)
            .catch((e) => {
                loadingHTML = false;
                error = e;
                is_requesting = false;
                throw new Error(e.message);
            });
        if (should_save) {
            await saveReport(config, summary_id, snapshot.id).catch((e) => {
                loadingHTML = false;
                is_requesting = false;
                error = e;
                throw new Error(e.message);
            });
        }

        if (file) {
            const fileBlob = await file.blob();
            const fileUrl = URL.createObjectURL(fileBlob);
            const anchor = document.createElement("a");
            anchor.href = fileUrl;
            anchor.download = file_name;
            document.body.appendChild(anchor);
            anchor.click();
            document.body.removeChild(anchor);

            URL.revokeObjectURL(fileUrl);
        }
        is_requesting = false;
        if (!error) await getData();
        loadingHTML = false;
    };

    const saveReport = async (config, summary_id, snapshot_id) => {
        await snapshotService.saveReport(config, summary_id, snapshot_id);
    };

    const handleReportFilters = async (id, filter) => {
        let config = { filter: {} };
        let key = Object.keys(filter)[0];
        updateFilterValue(filters, key, filter[key]);
        let filtersCopy = JSON.parse(JSON.stringify(filters));
        for (let [k, v] of Object.entries(filtersCopy)) {
            if (v.length && k != "format" && k != "language")
                config.filter[k] = v;
        }
        if (id) {
            await getSnapshotDetail(id, config);
        }
    };

    onMount(async () => {
        await getData();
        await tick();
        selectAllEventListener();

        const editEl = document.getElementById("report-edit-modal");
        if (editEl) {
            editEl.addEventListener("hidden.bs.modal", () => {
                editingReport = null;
                deselectAll();
            });
        }
    });

    onDestroy(() => {
        if (checkbox) checkbox.removeEventListener("click", selectAll);
        closeModal("report-edit-modal");
        closeModal("snapshot-report-modal");
    });
</script>

<section class="content-header">
    <div class="container-fluid">
        <div class="row">
            <div class="col-6">
                <h1 class="mt-3 mb-3 page-title">
                    <i class="fas fa-file-contract fa-xs"></i>
                    {$format("page.report.title")}
                </h1>
            </div>
            <div class="col-6">
                <BreadCrumNav routes={[{ label: $format("page.report.title") }]} />
            </div>
        </div>
    </div>
</section>

{#key refresh}
    <section class="content">
        <div class="container-fluid">
            <div class="card">
                <div class="card-header">
                    <div class="card-tools float-end">
                        {#if user.data.role != "viewer"}
                            <button
                                class="btn btn-secondary table-button btn-add btn-xs t-add-report-btn"
                                tabindex="0"
                                aria-controls="reportsTable"
                                type="button"
                                title={$format("buttons.add")}
                                id="reportaddBtn"
                                aria-label="add"
                                onclick={() => openModal("snapshot-report-modal")}
                            ><i class="fa fa-plus"></i></button>
                            <button
                                disabled
                                class="btn btn-secondary btn-disabled table-button btn-delete btn-xs t-delete-report-btn"
                                tabindex="0"
                                aria-controls="reportsTable"
                                type="button"
                                title={$format("buttons.delete")}
                                aria-label="delete"
                                id="reportDeleteBtn"
                                onclick={() => handleDelete(reports)}
                            ><i class="fa fa-trash"></i></button>
                            <button
                                disabled
                                class="btn btn-secondary btn-disabled table-button btn-edit btn-xs t-edit-report-btn"
                                tabindex="0"
                                aria-controls="reportsTable"
                                type="button"
                                title={$format("buttons.edit")}
                                id="reportEditBtn"
                                aria-label="edit"
                                onclick={handleEdit}
                            ><i class="fa fa-edit"></i></button>
                        {/if}
                        <button
                            class="btn btn-secondary table-button btn-refresh btn-xs t-refresh-report-btn"
                            tabindex="0"
                            aria-controls="reportsTable"
                            type="button"
                            title={$format("buttons.refresh")}
                            id="reportRefreshBtn"
                            aria-label="refresh"
                            onclick={getData}
                        ><i class="fa fa-sync-alt"></i></button>
                    </div>
                </div>
                <div class="card-body">
                    <div class="table-responsive">
                        <div class="overlay-wrapper">
                            <div class="text-center" class:overlay={is_requesting}>
                                <i class="fas fa-2x fa-sync-alt fa-spin"></i>
                            </div>
                        </div>
                        <PowerTable
                            ptData={reports}
                            ptInstructs={instructs}
                            {ptOptions}
                            on:rowClicked={(e) => selectRow(e)}
                            bind:this={tableElement}
                        />
                    </div>
                </div>
            </div>
        </div>
    </section>
{/key}

<SnapshotModal
    {snapshot}
    {filters}
    showBtn={true}
    is_requesting={is_loading_snapshot}
    {saveNewSnapshot}
    {handleReportFilters}
    {handleReportDownload}
/>

<!-- MODAL -->
<div
    class="modal fade"
    id="report-edit-modal"
    tabindex="-1"
    aria-hidden="true"
>
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <button
                    type="button"
                    class="btn-close"
                    aria-label="Close"
                    onclick={handleCancel}
                ></button>
            </div>
            <div class="modal-body">
                {#if editingReport}
                    <Form
                        report={editingReport}
                        onsave={handlePatchFunction}
                        oncancel={handleCancel}
                    />
                {/if}
            </div>
        </div>
    </div>
</div>

<style>
    .overlay-wrapper div {
        display: none;
    }
    .overlay-wrapper div.overlay {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        margin-top: 20px;
    }
</style>